<template>
  <div class="p-3 my-3 developmentGoals" v-if="passdevelopmentgoals && passdevelopmentgoals.length > 0">
    <K2Text bold="true" :color="uiVariable.color.purple" class="mb-2 d-block" v-if="postType === 'Feed'">{{ lang('Analysis') }} </K2Text>
    <K2Text bold="true" :color="uiVariable.color.purple" class="mb-2 d-block" v-else>
      {{ isMoment ? lang('Analysis (moment)') : lang('Analysis') }}
    </K2Text>
    <div>
      <div v-for="item of goalListInOrder" :key="item.KeyId">
        <K2Text bold="true">{{ item.Domain }}</K2Text>
        <K2Row v-for="indicator of item.ItemList" :key="indicator.Indicator" class="mb-2">
          <K2Icon name="check_circle" :color="uiVariable.color.purple" font-size="16px" class="mt-1 me-2" />
          <div v-if="indicator.Goals &&  indicator.PlnMasType !== '3LAYER_2026'">
            <template v-if="indicator.Goals">
              <K2Text :color="uiVariable.color.purple">Learning Goal: {{ indicator.Goals }}</K2Text><br />
            </template>
            <span v-html="indicator.Indicator" />
          </div>
          <div v-else>
            <span v-html="indicator.Indicator" />
          </div>
        </K2Row>
      </div>
    </div>
  </div>
</template>
<script>
import { lang } from '../../../locale/index'
import uiVariable from '../../../config/uiVariable'
import K2Text from '../../../uiComponents/k2Text/k2Text'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Icon from '../../../uiComponents/k2Icon/k2MAIcon'
import { reorderArray } from '@/helper/utily'

export default {
  name: 'activityPreviewGoal',
  components: { K2Icon, K2Row, K2Text },
  props: ['passdevelopmentgoals', 'postType', 'isPublished', 'parentPost', 'isMoment'],
  data() {
    return {
      uiVariable: uiVariable,
      goalListInOrder: [],
    }
  },
  mounted() {
    this.reorderGoals()
  },
  methods: {
    lang,
    reorderGoals() {
      let hasOrderID = this.parentPost?.PostLearningMomentsGrouping?.[0]?.ItemList?.[0]?.PostUpLMPlnMasID !== null

      if (this.isPublished) {
        this.parentPost.PostLearningMomentsGrouping?.map(goal => {
          let PostUpLMPlnMasID = goal?.ItemList?.[0]?.PostUpLMPlnMasID?.replace('PLM', '')
          goal.PlnMasOrder = PostUpLMPlnMasID?.replace('PLM', '')
          goal.ItemList?.forEach(item => {
            item.Indicator = item?.PostUpLMIndicator
            item.Goals = item?.PostUpLMGoals
          })
        })
        this.goalListInOrder = hasOrderID ? reorderArray(this.parentPost.PostLearningMomentsGrouping) : this.parentPost.PostLearningMomentsGrouping
      } else {
        if (this.passdevelopmentgoals?.length) {
          this.passdevelopmentgoals?.map(goal => {
            goal.PlnMasOrder = goal?.ItemList?.[0]?.KeyId?.replace('PLM', '')
          })
        }
        this.goalListInOrder = hasOrderID ? reorderArray(this.passdevelopmentgoals) : this.passdevelopmentgoals
      }
    },
  },
}
</script>
